import React from 'react';
import { UserAvatar } from '../ui/user-avatar';

interface SidebarUserProfileProps {
  user: {
    name?: string;
    email?: string;
    avatar?: string;
  };
  onClick?: () => void;
}

export function SidebarUserProfile({ user, onClick }: SidebarUserProfileProps) {
  const displayName = user.name || 'Пользователь';
  const displayEmail = user.email || '';

  // Разделяем имя на firstName и lastName для UserAvatar
  const nameParts = displayName.split(' ');
  const firstName = nameParts[0] || '';
  const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

  return (
    <div className="px-2.5 py-3 mt-auto">
      <button
        data-testid="sidebar-user-profile"
        className="w-full bg-[#F5F6F1] rounded-xl px-2.5 py-3 flex items-center gap-2 hover:opacity-70 transition-opacity"
        onClick={onClick}
      >
        <UserAvatar
          firstName={firstName}
          lastName={lastName}
          email={displayEmail}
          size="md"
          className="flex-shrink-0"
        />
        <div className="flex-1 min-w-0 text-left">
          <div data-testid="sidebar-user-profile-name" className="text-[15px] font-medium text-[var(--text-dark)] truncate">
            {displayName}
          </div>
          <div data-testid="sidebar-user-profile-email" className="text-[12px] text-[var(--text-tertiary)] truncate">
            {displayEmail}
          </div>
        </div>
      </button>
    </div>
  );
}
